<template>
  <div>
    <el-card class="mat12">
      <div class="main">
        <div class="main-info" v-if="dataDesc.project.projectType == 1">
          <el-col :span="6" class="name media_col">
             普通保安员岗：
            <i class="num">{{dataDesc.proCost.cost1?dataDesc.proCost.cost1:0}}元</i>
          </el-col>

          <el-col :span="6" class="name media_col">
            形 象 岗：
            <i class="num">{{dataDesc.proCost.cost4?dataDesc.proCost.cost4:0}}元</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            中 控 岗：
            <i class="num">{{dataDesc.proCost.cost5?dataDesc.proCost.cost5:0}}元</i>
          </el-col>
          <el-col :span="6" class="name media_col">
             班 长岗：
            <i class="num">{{dataDesc.proCost.cost8?dataDesc.proCost.cost8:0}}元</i>
          </el-col>

          <el-col :span="6" class="name media_col">
            副队长岗：
            <i class="num">{{dataDesc.proCost.cost7?dataDesc.proCost.cost7:0}}元</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            兼职队长岗：
            <i class="num">{{dataDesc.proCost.cost3?dataDesc.proCost.cost3:0}}元</i>
          </el-col>

          <el-col :span="6" class="name media_col">
            专职队长岗：
            <i class="num">{{dataDesc.proCost.cost2?dataDesc.proCost.cost2:0}}元</i>
          </el-col>

        </div>
        <div class="main-info" v-if="dataDesc.project.projectType == 1">
           <el-col :span="6" class="name media_col" v-if="dataDesc.project.projectType == 1">
            月服务费：
            <i class="num">{{dataDesc.proCost.cost6?dataDesc.proCost.cost6:0}}元</i>
          </el-col>
        </div>
        <div class="main-info">

          <el-col :span="6" class="name media_col" v-if="dataDesc.project.projectType != 1">
            总服务费：
            <i class="num">{{dataDesc.proCost.totalCost?dataDesc.proCost.totalCost:0}}元</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            滞纳金比例：
            <i class="num">{{dataDesc.proCost.lateFee}} ‰</i>
          </el-col>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CardProjectServiceCharge", // 服务费
  props: {
    dataDesc: {
      type: Object,
      default: {}
    }
  },
  created() {
    // console.log(this.dataDesc.project.projectType);
  }
};
</script>

<style lang="scss" scoped>
.main {
  padding-top: 20px;
}
.title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 20px;
}
.main-info {
  display: flex;
  flex-wrap: wrap;
  i {
    font-style: normal;
  }
  .name {
    font-weight: bold;
    margin-bottom: 20px;
  }
  .num {
    font-weight: 400;
  }
}
</style>
